// extracted by mini-css-extract-plugin
module.exports = {"arrow":"Arrow-module--arrow--2jXBS","arrowBack":"Arrow-module--arrowBack--djgmV","gray":"Arrow-module--gray--i6r5T","bigOffset":"Arrow-module--bigOffset--1jtEa"};